<div [formGroup]="fg()">
  <div class="action-setting">
    <div class="action-setting-title">
      {{ 'commonActions.webBrowsing.description' | labelsProvider }}
    </div>

    <mat-radio-group [value]="webBrowsingMode()" (change)="onRadioButtonChange($event.value)">
      <div class="radio-option">
        <mat-radio-button [value]="true">
          {{ 'commonActions.webBrowsing.enableLabel' | labelsProvider }}
        </mat-radio-button>
        <div class="radio-description">
          {{ 'commonActions.webBrowsing.enableDescription' | labelsProvider }}
        </div>
      </div>

      <div class="radio-option">
        <mat-radio-button [value]="false">
          {{ 'commonActions.webBrowsing.disableLabel' | labelsProvider }}
        </mat-radio-button>
        <div class="radio-description">
          {{ 'commonActions.webBrowsing.disableDescription' | labelsProvider }}
        </div>
      </div>
    </mat-radio-group>
  </div>
</div>
